import React, { memo } from 'react';
import { useBranding } from '@src/theme/branding/useBranding';
import SideDrawerElement from '../sideDrawerElement';
import { SIDE_MENU_EVENTS } from '../sideMenu';
import { Tabs, Button } from 'antd';
import type { TabsProps } from 'antd';

const Assets3D = ({
  items,
  callBack,
  inProgress,
  type,
  session,
  selectedSceneTemplate,
}) => {
  const { isZepeto } = useBranding();

  if (isZepeto) {
    return (
      <>
        {items['Pack2'].map((element, index) => {
          return (
            <SideDrawerElement
              classes={''}
              inProgress={inProgress}
              key={element.id || `${type}-${index}`}
              thumbnail={element.thumbnail}
              callback={() => {
                callBack({ ...element, type, index });
              }}
            />
          );
        })}
      </>
    );
  }

  return (
    <>
      <Tabs
        defaultActiveKey='1'
        items={
          type === SIDE_MENU_EVENTS.LIBRARY_3D
            ? (Object.keys(items).map((tabName, index) => {
                return {
                  key: `${index + 1}`,
                  label: tabName,
                  disabled:
                    session?.user.role !== 'admin' &&
                    (tabName === 'Pack3' || tabName === 'Pack2'),
                  children: (
                    <>
                      {items[tabName].map((element, index) => {
                        return (
                          <SideDrawerElement
                            classes={''}
                            inProgress={inProgress}
                            key={element.id || `${type}-${index}`}
                            thumbnail={element.thumbnail}
                            callback={() => {
                              callBack({ ...element, type, index });
                            }}
                          />
                        );
                      })}
                    </>
                  ),
                };
              }) as TabsProps['items'])
            : items.map((item, index) => {
                return {
                  key: `${index + 1}`,
                  label: item.tabName,
                  children: (
                    <>
                      {item.scenes.length > 0 ? (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '5px',
                          }}
                        >
                          {item.scenes.map((sceneOut, i) => {
                            return (
                              <Button
                                type='dashed'
                                key={i}
                                style={{ minHeight: 32, width: '100%' }}
                                className={`${
                                  selectedSceneTemplate ===
                                  sceneOut?.baseModelURL
                                    ? 'sidedrawer-element-selected'
                                    : ''
                                }`}
                                onClick={() => {
                                  callBack({
                                    type,
                                    baseModelURL: sceneOut.baseModelURL,
                                  });
                                }}
                              >
                                <span style={{ color: '#333333' }}>
                                  {sceneOut.name}
                                </span>
                              </Button>
                            );
                          })}
                        </div>
                      ) : (
                        <div>This mfe dont have scenes</div>
                      )}
                    </>
                  ),
                };
              })
        }
      />
    </>
  );
};

export default memo(Assets3D);
